import { Grid } from '@mantine/core';
import { Table } from '../table';

const Single = (props) => (
  <Grid>
    <Grid.Col span={12}>
      <Table {...props} />
    </Grid.Col>
  </Grid>
);

export default Single;
